import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgSchoonmaak = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M34 17.73 31.29 34H20.44l-2.71-16.27z"
    />
    <path
      fill="#F8BADD"
      d="M8.51 23.45c.59-2.12 3.75-3.71 6.85-2.85s5 3.87 4.38 6l-.6 2-11.23-3.15z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22.88 17.73a5.31 5.31 0 1 0 10.62 0h1a6.31 6.31 0 1 1-12.62 0z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M15.36 20.6c-3.1-.86-6.26.73-6.85 2.85l-2 7.14 2 .54 2.37-4.73-.42 5.28 7.33 2 2-7.14c.54-2.07-1.33-5.07-4.43-5.94"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m20.547 6.001-5.1 16.09-.954-.302 5.1-16.09z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgSchoonmaak);

export default ForwardRef;
